import axiosApi from 'modules/api'

const deleteOneOrder = async (
  orderId: string,
  orderMaker: string
): Promise<void> => {
  await axiosApi.delete(`/orders/${orderId}`, {
    params: {
      maker: orderMaker,
    },
  })
}

export default deleteOneOrder
